<template>
  <div class="pa-4">
    <RichText
      v-model="store.plan.life_cycle_costs"
      label="7.1 Life Cycle Costs"
      class="mb-4"
      required
      :readonly="readonly"
    />
    <RichText
      v-model="store.plan.replacement_value"
      label="7.1.1 Replacement Value"
      class="mb-4"
      required
      :readonly="readonly"
    />
    <RichText
      v-model="store.plan.budgets"
      label="7.2 Budgets"
      class="mb-4"
      required
      :readonly="readonly"
    />
    <RichText
      v-model="store.plan.sustaining_capital_budget"
      label="7.2.1 Sustaining Capital Budget"
      class="mb-4"
      required
      :readonly="readonly"
    />
    <RichText
      v-model="store.plan.capital_projects_budget"
      label="7.2.2 Capital Projects Budget"
      class="mb-4"
      required
      :readonly="readonly"
    />
    <RichText
      v-model="store.plan.life_cycle_cost_model"
      label="7.3 Life Cycle Cost Model"
      class="mb-4"
      required
      :readonly="readonly"
    />
    <RichText
      v-model="store.plan.end_of_life"
      label="7.4 End Of Life"
      class="mb-4"
      required
      :readonly="readonly"
    />
  </div>
</template>

<script setup lang="ts">
import RichText from "@/components/base/inputs/RichText.vue";
import { useAMPStore } from "@/store/asset-management-plan";

const props = defineProps<{
  readonly: boolean;
}>();

const store = useAMPStore();
</script>
